/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingpublishedinstagram2Inputs */

const en_crosspostingpublishedinstagram2 = /** @type {(inputs: Crosspostingpublishedinstagram2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published to Instagram.`)
};

const de_crosspostingpublishedinstagram2 = /** @type {(inputs: Crosspostingpublishedinstagram2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Instagram veröffentlicht.`)
};

/**
* | output |
* | --- |
* | "Published to Instagram." |
*
* @param {Crosspostingpublishedinstagram2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpublishedinstagram2 = /** @type {((inputs?: Crosspostingpublishedinstagram2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpublishedinstagram2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpublishedinstagram2(inputs)
	return de_crosspostingpublishedinstagram2(inputs)
});
export { crosspostingpublishedinstagram2 as "crosspostingPublishedInstagram" }